import React from "react";
import "../styles/team-member-configurations.css";

export type TeamMemberConfigRole = "admin" | "staff" | "coach" | "other";

export function teamMemberConfigRole(role: string | undefined | null): TeamMemberConfigRole {
    const normalized = (role || "").trim().toLowerCase();
    if (normalized === "coach") {
        return "coach";
    }
    if (normalized === "staff" || normalized.includes("staff")) {
        return "staff";
    }
    if (normalized === "admin" || normalized === "administrator" || normalized.includes("admin")) {
        return "admin";
    }
    return "other";
}

type Props = {
    role: string | undefined | null;
    internalCoachPreReadEnabled: boolean;
    manageStudentAthletesEnabled: boolean;
    onInternalCoachPreReadChange: (enabled: boolean) => void;
    onManageStudentAthletesChange: (enabled: boolean) => void;
};

export default function TeamMemberConfigurations({
    role,
    internalCoachPreReadEnabled,
    manageStudentAthletesEnabled,
    onInternalCoachPreReadChange,
    onManageStudentAthletesChange,
}: Props) {
    const configRole = teamMemberConfigRole(role);
    if (configRole === "other") {
        return null;
    }

    const isCoach = configRole === "coach";
    const enabled = isCoach ? manageStudentAthletesEnabled : internalCoachPreReadEnabled;
    const title = isCoach ? "Add & Manage Student-Athletes" : "Enable Internal Coach Pre-Read";
    const testId = isCoach ? "toggle-manage-student-athletes" : "toggle-internal-coach-pre-read";
    const switchId = isCoach ? "manage-student-athletes" : "internal-coach-pre-read";

    return (
        <div className="tmc-section tmc-section--full">
            <label className="tmc-heading" htmlFor={switchId}>
                CONFIGURATIONS
            </label>
            <div className="tmc-row">
                <div className="tmc-copy">
                    <span className="tmc-title">{title}</span>
                </div>
                <label className="tmc-switch">
                    <input
                        id={switchId}
                        type="checkbox"
                        role="switch"
                        data-testid={testId}
                        aria-label={title}
                        checked={enabled}
                        onChange={(event) => {
                            if (isCoach) {
                                onManageStudentAthletesChange(event.target.checked);
                            } else {
                                onInternalCoachPreReadChange(event.target.checked);
                            }
                        }}
                    />
                    <span className="tmc-slider" aria-hidden="true" />
                </label>
            </div>
        </div>
    );
}
